// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__WSGJa","ant-modal-confirm-error":"Modal_ant-modal-confirm-error__3gJJC","ant-btn-primary":"Modal_ant-btn-primary__pDaXy"};